import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../hooks/useAuth';
import FormBuilder from '../components/FormBuilder';

const CreateForm = () => {
  const navigate = useNavigate();
  const { token } = useAuth();
  const [saving, setSaving] = useState(false);

  const handleSave = async (formData) => {
    try {
      setSaving(true);
      await axios.post('/api/forms', formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      navigate('/forms');
    } catch (err) {
      alert('Failed to create form. Please try again.');
      console.error('Error creating form:', err);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    navigate('/forms');
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Create New Form</h1>
        <p className="text-gray-600 mt-1">Build a custom form to embed on your website</p>
      </div>

      {saving && (
        <div className="bg-blue-50 border border-blue-200 text-blue-700 px-4 py-3 rounded-md">
          Saving form...
        </div>
      )}

      <FormBuilder onSave={handleSave} onCancel={handleCancel} />
    </div>
  );
};

export default CreateForm;
